export default "__VITE_ASSET__a024a63b__"